module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABO0lEQVQokX2SvSvFURjHP/dm4c9QupOUTZQUUiYvA0WkWyJKMchgMRhQBoXJigkTkjApux15uW7kLcLwsZwfJ11Ofev5Pm/nOd/noFIAFepdQE2hnCJ+Th+QATaBfWAceAp2HdAMXAELAEmHIfVZPVJP1MWo+1zwHaiP6qj6Xbik7gY79cf4qOvqSlxYqt5GCa3qXkBn5D9Xy5PCWvVCXQ7BbvVTzao96oc6GGKzak5tRH1VB6Kup2pXxNvVs4j3qg9poBjIR+qmgeeIvwCpiOeBEtQW9VqdCR371Xe1Q21T39SxEJtU82pHcn1GvY8U7VePA4ajMS/VyljVeXX7nzUkWEt2nA5z54AqYAs4BKaiN00E3ybQANwApNQkYQQoA3aADSAbRFoFWoB64BqYjr/cb1QHEW7VpkI5X2Hp6DC2Iv3bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/icon_set.png
// module id = qPRM
// module chunks = 0